const typeConfigs = {
    'section': 'section',
    'questionData': 'questionData',
    'questionList': 'questionList',
    'answerData': 'answerData',
    'answerDataWhitOutReincidence': 'answerDataWhitOutReincidence',
    'answerDataGeneral': 'answerDataGeneral',
    'questionListWhitAll': 'questionListWhitAll',
    answerList: 'answerList',
} as const

export { typeConfigs }
